import { defineComponent, h } from 'vue';
import { t } from '@/ui/i18n/i18n';

export const UnknownQuestion = defineComponent({
  name: 'UnknownQuestion',
  props: ['item'],
  setup(props) {
    return function render() {
      return h('div', [t('inspection-report.unknown', { type: props.item.response_type })]);
    };
  },
});
